var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8957 6.78612L5.39662 18.9327C3.24694 19.7961 3.25938 20.9953 5.00222 21.5301L13.0893 24.0529L31.8004 12.2474C32.6851 11.7091 33.4935 11.9986 32.829 12.5885L17.6693 26.27H17.6658L17.6693 26.2718L17.1115 34.6076C17.9287 34.6076 18.2894 34.2327 18.7477 33.7904L22.6758 29.9707L30.8464 36.0058C32.3529 36.8355 33.4349 36.4091 33.8097 34.6112L39.1733 9.33376C39.7222 7.13255 38.3329 6.13588 36.8957 6.78612Z",
    fill: "url(#paint0_linear_1_1117)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1117",
    x1: 21.516,
    y1: 14.4843,
    x2: 21.5161,
    y2: 52.2012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.ee5ddb60a07f67b63e8c8693289f1ccd.svg";
export { ForwardRef as ReactComponent };